<template>
  <div class="notification-container" v-if="hasNotification">
    <button class="iconButton" v-on:click="clearNotification($event)">
      <BaseIcon name="x-square"/>
    </button>
    <h4>{{NotificationStore.notification}}</h4>
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon.vue";
import { mapState, mapGetters } from "vuex";

export default {
  components: { BaseIcon },
  computed: {
    ...mapState(["NotificationStore"]),
    ...mapGetters(["hasNotification"])
  },
  methods: {
    clearNotification: function(args) {
      args.preventDefault();
      this.$store.dispatch("clearNotification");
    }
  }
};
</script>

<style scoped>
.notification-container {
  position: fixed;
  display: inline-flex;
  align-items: center;
  bottom: 0;
  right: 0;
  padding-right: 40px;
}
.iconButton {
  background: transparent;
  border: 0;
  cursor: pointer;
}
</style>
